import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ScreenMobileAppInfoComponent } from '@kp/screen-mobile-app-info/screen-mobile-app-info.component';
import { SharedModule } from '@kp/shared/shared.module';

const routes: Routes = [{ path: '', pathMatch: 'full', component: ScreenMobileAppInfoComponent }];

@NgModule({
  declarations: [ScreenMobileAppInfoComponent],
  imports: [CommonModule, RouterModule.forChild(routes), SharedModule],
  exports: [RouterModule],
})
export class ScreenMobileAppInfoModule {}
